var Controller = require('controllers/base/controller');
var PageView = require('views/page/page-view');
var PageService = require('services/page-service');
var SessionService = require('services/session-service');
var LocaleService = require('services/locale-service');

var PageController = Controller.extend({
  show: function(params, route, options) {
    if(params.module && $.isNumeric(params.module.charAt(0))) {
      console.warn("Module names cannot begin with a number. Rename the module such that the first character is not a number");
    }

    PageService.loadPage(params.module, params.activity, params.page).then((page) => {
      SessionService.set('queryParams', options.query);
      if (PageService.preventSkippingPages(page, params)) {
        let linkedPage = page.get('link');
        let previouslyCompleted = page.get('completed') ? 'previously-completed' : '';
        let userSpecifiedClass = page.get('class') || '';
        let className = linkedPage ? `${linkedPage.page} ${linkedPage.activity} ${linkedPage.module} ${previouslyCompleted} ${userSpecifiedClass} ${LocaleService.getLanguage()}` :
          `${page.get('key')} ${page.get('activityKey')} ${page.get('moduleKey')} ${previouslyCompleted} ${userSpecifiedClass} ${LocaleService.getLanguage()}`;

        if (page.get('transition') && !page.get('transition-in')) {
          //console.log(`rendering ${page.get('key')} without transition-in; setting transition-in to ${page.get('transition-in')}`);
          page.set('transition-in', 'forward');
        }

        this.view = new PageView({
          region: 'main',
          model: page,
          className: className
        });
        //TODO: revisit trying to reuse the actionbarview, was moved to the page-view.play
        //this.reuse('actionbar', ActionBarView, {region: 'actionbar'});
        this.view.play();
      }
    });
  }
});

module.exports = PageController;
